import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center tw-text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "tw-my-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "tw-my-8" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadQuestions = _resolveComponent("ReadQuestions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.userFullName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Hello " + _toDisplayString(_ctx.userFullName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "sf-btn-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleSetMode('practice')), ["prevent"]))
            }, " Begin Practice "),
            _createElementVNode("button", {
              class: "sf-btn-primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleSetMode('test')), ["prevent"]))
            }, " Begin Test ")
          ])
        ]))
      : (_ctx.loadingProgress >= 0 && _ctx.loadingProgress < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " loading " + _toDisplayString(Math.floor(_ctx.loadingProgress * 100)) + "% ", 1))
        : _createCommentVNode("", true),
    (_ctx.step == 2 && _ctx.loadingProgress >= 1)
      ? (_openBlock(), _createBlock(_component_ReadQuestions, {
          key: 2,
          onSelect: _ctx.handleRedSentences
        }, null, 8, ["onSelect"]))
      : _createCommentVNode("", true)
  ]))
}